import { FormFieldsGeneratorService } from './../../customer-form/form-helpers/form-fields-generator.service';
import { FormCustomValidators } from './../../customer-form/form-helpers/form-custom-validators';
import { ProcessTypeEnum } from '../../models/cartDetails/process-type.enum';
import { AppInjector } from '../../utils/services/set-app-injector';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';
import { FormControl, Validators, FormGroup } from '@angular/forms';

export default abstract class AbstractAuthService {

  protected msisdn: string;
  protected otpPasswordForTesters: string;
  protected bundleNumber: number;
  protected processType: ProcessTypeEnum;

  protected abstract submitNumberEndpoint: string;
  protected abstract submitPasswordEndpoint: string;

  protected resolve: Function;
  protected reject: Function;

  private endpoint: any = AppInjector.get('Endpoint');
  private commonModalService: CommonModalService = AppInjector.get(CommonModalService);
  private isPasswordSentAgain = false;
  private formsGeneratorService: FormFieldsGeneratorService = AppInjector.get(FormFieldsGeneratorService);


  public startProcess(bundleNumber: number, msisdn: string, processType: ProcessTypeEnum): Promise<any> {
    const promise = new Promise((resolve: Function, reject: Function) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    this.msisdn = msisdn;
    this.bundleNumber = bundleNumber;
    this.otpPasswordForTesters = null;
    this.processType = processType;

    this.submitNumber();

    return promise;
  }

  private submitNumber(): void {
    this.endpoint(this.submitNumberEndpoint, this.makeSubmitNumberData())
      .run()
      .then((response: string) => {
        this.handleSubmitNumberResponse(response);
      })
      .catch((error: any) => {
        console.warn(error);
        this.showFailureModal();
      });
  }

  private submitPasswordForm(modalData: any, event: Event): void {
    setTimeout(() => {
      if (this.commonModalService.isFormValid(event)) {
        modalData.isLoaderVisible = true;

        this.endpoint(this.submitPasswordEndpoint, this.makeSubmitPasswordData(modalData.password))
          .run()
          .then((response) => {
            this.handleSubmitPasswordResponse(response);
          })
          .catch((error) => {
            console.warn(error);
            this.showFailureModal();
          });
      }
    });
  }

  protected abstract handleSubmitNumberResponse(submitNumberResponse: any): void;

  protected abstract handleSubmitPasswordResponse(submitPasswordResponse: any): void;

  protected abstract makeSubmitNumberData(): any;

  protected abstract makeSubmitPasswordData(password: string): any;

  protected showPasswordModal(): void {
    let modalData: any = {};
    const numberVerificationForm = new FormGroup({
      smsCode: new FormControl('', [Validators.required, FormCustomValidators.smsCode])
    });

    if (this.isPasswordSentAgain) {
      modalData = this.commonModalService.createModalData(CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS_SENT_AGAIN);
      (modalData.numberVerificationAgainForm as FormGroup) = numberVerificationForm;
    } else {
      modalData = this.commonModalService.createModalData(CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS);
      (modalData.numberVerificationForm as FormGroup) = numberVerificationForm;
    }

    this.formsGeneratorService.setModalForm(numberVerificationForm);
    modalData.msisdn = this.msisdn;
    modalData.otpPasswordForTesters = this.otpPasswordForTesters;
    modalData.requestNewPassword = (event: Event) => {
      event.preventDefault();

      this.isPasswordSentAgain = true;

      this.submitNumber();
    };
    modalData.submitPassword = (event: Event) => {
      event.preventDefault();

      this.submitPasswordForm(modalData, event);
    };

    this.commonModalService.setData(
      modalData,
      () => this.isPasswordSentAgain = false,
      this.reject
    );
  }

  public showFailureModal(): void {
    this.commonModalService.setData({
      templateName: CommonModalTemplatesEnum.NUMBER_VERIFICATION_FAILURE
    }, this.reject);
  }

  protected showPasswordErrorModal(): void {
    const numberVerificationErrorForm = new FormGroup({
      smsCode: new FormControl('', [Validators.required, FormCustomValidators.smsCode])
    });
    const modalData: any = this.commonModalService.createModalData(CommonModalTemplatesEnum.INCORRECT_PASSWORD);
    (modalData.numberVerificationErrorForm as FormGroup) = numberVerificationErrorForm;

    modalData.msisdn = this.msisdn;
    modalData.otpPasswordForTesters = this.otpPasswordForTesters;
    modalData.resendPassword = ($event: MouseEvent) => {
      $event.preventDefault();

      this.isPasswordSentAgain = true;

      this.submitNumber();
    };

    modalData.submitPassword = ($event: MouseEvent) => {
      $event.preventDefault();

      this.submitPasswordForm(modalData, $event);
    };

    this.commonModalService.setData(modalData, [this.reject, () => this.isPasswordSentAgain = false]);
  }
}
